import { FC, ReactNode } from 'react'
import styled from 'styled-components'
import { Transition } from 'react-transition-group'
import { TransitionStatus } from 'react-transition-group/Transition'
import { Button } from './Button'

type DialogProps = {
  isShow: boolean
  title: string
  submitButtonTitle?: string
  onClose: () => void
  children: ReactNode
  onSubmit: () => void | Promise<void>
}

export const Dialog: FC<DialogProps> = (props) => {
  const { isShow, onClose, title, children, submitButtonTitle = 'OK', onSubmit } = props
  return (
    <Wrap isShow={isShow}>
      <Transition in={isShow} timeout={550}>
        {(state) => (
          <>
            <StyledContent state={state}>
              <StyledTitle>{title}</StyledTitle>
              <div>{children}</div>
              <StyledButtonWrap>
                <Button buttonType="text" onClick={onClose}>
                  キャンセル
                </Button>
                <StyledSpace />
                <Button buttonType="contained" onClick={onSubmit}>
                  {submitButtonTitle}
                </Button>
              </StyledButtonWrap>
            </StyledContent>
            <Shadow onClick={onClose} state={state} />
          </>
        )}
      </Transition>
    </Wrap>
  )
}

const Wrap = styled.div<{ isShow: boolean }>`
  height: 100vh;
  top: 0px;
  left: 0px;
  display: flex;
  z-index: 1;
  position: fixed;
  width: ${({ isShow }) => (isShow ? '100%' : 'auto')};
`

const Shadow = styled.div<{ state: TransitionStatus }>`
  opacity: ${({ state }) => (state === 'entering' || state === 'entered' ? 0.75 : 0)};
  background: rgb(0, 0, 0);
  flex: 2 1 0%;
  width: ${({ state }) => (state === 'exited' ? '0px' : '100vw')};
  transition: 0.2s;
  height: 100%;
`
const StyledContent = styled.div<{ state: TransitionStatus }>`
  opacity: ${({ state }) => (state === 'entering' || state === 'entered' ? 1 : 0)};
  display: ${({ state }) => (state === 'exited' ? 'none' : 'block')};
  text-align: center;
  padding: 20px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #fff;
  z-index: 100;
  min-width: 350px;
  transition: 0.2s;
`

const StyledTitle = styled.p`
  font-weight: bold;
  font-size: 18px;
  margin-bottom: 30px;
`
const StyledButtonWrap = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 30px;
`
const StyledSpace = styled.div`
  width: 20px;
`
